import React from "react";

const pillStyle = (color, bg) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: "3px 12px",
  borderRadius: "9999px",
  fontSize: "12px",
  fontWeight: "600",
  background: bg,
  color,
  border: `1px solid ${color}`,
});

function LowStockBadge({ currentQty, reorderLevel }) {
  const qty = Number(currentQty);
  const reorder = Number(reorderLevel);
  if (qty <= 0) {
    return <span style={pillStyle("var(--button-color)", "#FFF3F3")}>Out of stock</span>;
  }
  if (qty <= reorder) {
    return <span style={pillStyle("#D97706", "#FEF3C7")}>Low stock</span>;
  }
  return <span style={pillStyle("#27AE60", "#E6F9F0")}>In stock</span>;
}

export default LowStockBadge;
